module.exports = __webpack_public_path__ + "static/img/pic_login.b3d1b8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic_login.jpg
// module id = L2l1
// module chunks = 1